import React from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

import servicioFormatos from '../../../servicio/ServicioFormatos';
import servicioArchivos from '../../../servicio/ServicioArchivos';
import servicioHttp from '../../../servicio/ServicioHttp';

export const TablaConsultaSolicitudesSat = (props) => {

    const { paginacion } = props;
    const {urlDescarga}= props;
    let { growl } = props;

    const templateFechaInicial = (rowData, column) =>{
        return servicioFormatos.formatearFechaString(rowData.fechaInicial);
    }
    const templateFechaFinal = (rowData, column) =>{
        return servicioFormatos.formatearFechaString(rowData.fechaFinal);
    }

    const templateDescarga = (rowData, column) => {
        let { numeroCfdi } = rowData;
        if (numeroCfdi !== 0) {
            return <div className="p-grid">
                       <div className="p-col-12 p-md-12">
                          <Button label="Excel" icon="pi-md-file-download" onClick={() => descargar(rowData)} />
                        </div>
                   </div>
        }
    }

    const descargar = (rowData) => {
        let { id }=rowData;
        servicioHttp.consumirPostHttp(urlDescarga,{id}).then(response => {
            let {data} =response;
            if(data.error){
                growl.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 10000 });
            }else{
                let {objeto}=data;
                let arregloBytes = servicioArchivos.base64ToArrayBuffer(objeto.contenido);
                servicioArchivos.guardarByteArray(objeto.nombre,arregloBytes);
            }
        }).catch(error => {
            growl.current.show({ severity: 'error', summary: 'Error', detail: "Existe un error al descargar el archivo, contacte a un administrador", life: 10000 });
        });
    }

    return (<div>
        <DataTable value={paginacion.datos} responsive={true} header="Solicitudes Descarga Cfdi SAT" autoLayout={true}>
            <Column body={templateFechaInicial} header="Fecha Inicial" />
            <Column body={templateFechaFinal} header="Fecha Final" />
            <Column field="rfcEmisor" header="Rfc Emisor" />
            <Column field="rfcReceptor" header="Rfc Receptor" />
            <Column field="rfcSolicitante" header="Rfc Solicitante" />
            <Column field="tipoComprobante" header="Tipo Comprobante" />
            <Column field="idSolicitud" header="Id Solicitud del SAT" />
            <Column field="codEstatus" header="Cod Estatus" />
            <Column field="mensaje" header="Mensaje" />
            <Column field="numeroCfdi" header="Numero Cfdi" />
            <Column body={templateDescarga} header="Descargar" /> 
        </DataTable>
    </div>);
}